import { ResultCardContainer } from './resultCardContainer';
import { ResultCardContent } from './resultCardContent';
import { ResultCardHeader } from './resultCardHeader';
import { ResultCardImage } from './resultCardImage';
import { ResultCardMetadata } from './resultCardMetadata';
import { ResultCardTag } from './resultCardTag';

export const ResultCard = {
  Container: ResultCardContainer,
  Header: ResultCardHeader,
  Image: ResultCardImage,
  Content: ResultCardContent,
  Metadata: ResultCardMetadata,
  Tag: ResultCardTag,
};
